import { render, staticRenderFns } from "./previewer.vue?vue&type=template&id=08353c52&scoped=true"
import script from "./previewer.vue?vue&type=script&lang=js"
export * from "./previewer.vue?vue&type=script&lang=js"
import style0 from "./previewer.vue?vue&type=style&index=0&id=08353c52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08353c52",
  null
  
)

export default component.exports